import { useEffect } from 'react';

import { startPostHogSessionRecording, stopPostHogSessionRecording } from '../../services/posthog';

/**
 * Manages PostHog session recording for a component's lifetime.
 *
 * - Without arguments: starts recording on mount, stops on unmount.
 *   Use this in route layouts that represent a key product flow.
 * - With `isActive`: starts when true, stops when false, and always stops on unmount.
 *   Use this for modals or conditional flows where recording is tied to an open state.
 *
 * @see https://posthog.com/docs/session-replay/how-to-control-which-sessions-you-record#programmatically-start-and-stop-recordings
 */
export function usePostHogSessionRecording(isActive = true): void {
  useEffect(
    function () {
      if (!isActive) {
        stopPostHogSessionRecording();
        return;
      }

      startPostHogSessionRecording();
      return function () {
        stopPostHogSessionRecording();
      };
    },
    [isActive]
  );
}
